import React from "react";
import { Box, Text } from "@chakra-ui/react";

const Footer = () => {
  return (
    <Box bg="black" p={4}>
      <Text textAlign="center" color="white">
        © 2024 NZCE. All rights reserved.
      </Text>
    </Box>
  );
};

export default Footer;
